import { render, staticRenderFns } from "./eSportsTeachers.vue?vue&type=template&id=574f81f8&scoped=true"
import script from "./eSportsTeachers.vue?vue&type=script&lang=js"
export * from "./eSportsTeachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f81f8",
  null
  
)

export default component.exports